import React, { memo, useCallback } from 'react';
import classNames from 'classnames/bind';
import { ReloadIcon, Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var PriceNotLoaded = /*#__PURE__*/memo(function (_ref) {
  var priceNotLoadedCallback = _ref.priceNotLoadedCallback;
  var onClick = useCallback(function (e) {
    if (priceNotLoadedCallback) {
      return priceNotLoadedCallback(e);
    }
    document.location.reload();
    return null;
  }, [priceNotLoadedCallback]);
  return /*#__PURE__*/React.createElement("button", {
    className: cn('price-not-loaded'),
    onClick: onClick,
    type: "button",
    "data-t-id": "components-PriceNotLoaded"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('price-not-loaded__icon')
  }, /*#__PURE__*/React.createElement(ReloadIcon, {
    size: "s"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('price-not-loaded__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0430\u0431\u043E\u043D\u0435\u043D\u0442\u0441\u043A\u0443\u044E \u043F\u043B\u0430\u0442\u0443"), /*#__PURE__*/React.createElement("div", {
    className: cn('price-not-loaded__description')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size6-r"
  }, "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043D\u0435 \u0431\u044B\u043B\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E \u0432 \u043E\u0442\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F"))));
});